/**
 * Splits Facebook DYI context strings like "You commented on Page Name's post."
 * so the page/target segment can be styled larger. Returns null if the pattern is not found.
 */
export function splitFacebookCommentContextTitle(text) {
  if (!text || typeof text !== 'string') return null;
  const marker = 'commented on ';
  const idx = text.indexOf(marker);
  if (idx < 0) return null;
  const lead = text.slice(0, idx + marker.length);
  const rest = text.slice(idx + marker.length);
  const pos = rest.indexOf("'s ");
  if (pos < 0) return null;
  const pageName = rest.slice(0, pos);
  const suffix = rest.slice(pos);
  return { lead, pageName, suffix };
}

export function formatCommentExportTime(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
}
